"use client";

import { memo, useCallback, useState } from "react";
import { useTranslations } from "next-intl";
import { getDebugEvents, sanitizeDebugEvent } from "../debug-store";

interface ExportButtonProps {
  pathname: string;
}

export const ExportButton = memo(function ExportButton({
  pathname,
}: ExportButtonProps) {
  const t = useTranslations("debug.export");
  const [exported, setExported] = useState(false);

  const handleExport = useCallback(() => {
    const payload = {
      exportedAt: new Date().toISOString(),
      version: "1",
      pathname: pathname.split(/[?#]/, 1)[0],
      events: getDebugEvents().map((event) => ({
        ...sanitizeDebugEvent(event),
        occurredAt: event.occurredAt,
      })),
    };

    const blob = new Blob([JSON.stringify(payload, null, 2)], {
      type: "application/json",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `debug-${Date.now()}.json`;
    a.click();
    URL.revokeObjectURL(url);

    setExported(true);
    setTimeout(() => setExported(false), 2000);
  }, [pathname]);

  return (
    <button
      onClick={handleExport}
      title={t("title")}
      className="hidden sm:inline-flex items-center gap-1 px-2 py-0.5 rounded border border-border bg-muted text-sm text-muted-foreground font-mono hover:text-foreground hover:border-border/80 transition-colors cursor-pointer"
    >
      {exported ? t("saved") : t("action")}
    </button>
  );
});
